import AddPost from "../add-post";
import PostsList from "../posts-list";
import { useStatistics } from "../../service/useStatistics";
import {
  FiFileText,
  FiFolder,
  FiStar,
  FiTrendingUp,
  FiCalendar,
  FiPlusCircle,
} from "react-icons/fi";

const AdminContent = ({ activeTab }) => {
  const renderContent = () => {
    switch (activeTab) {
      case "/":
      case "/dashboard":
        return <DashboardOverview />;
      case "/posts":
      case "/postsList":
        return <PostsList />;
      case "/add-post":
        return <AddPost />;
      default:
        return <PostsList />;
    }
  };

  return <div className="w-full">{renderContent()}</div>;
};

// Dashboard overview component with real statistics
const DashboardOverview = () => {
  const stats = useStatistics();

  const statCards = [
    {
      title: "Gjithsej postime",
      value: stats.totalPosts,
      icon: FiFileText,
      color: "blue",
      bgColor: "bg-blue-100",
      textColor: "text-blue-600",
    },
    {
      title: "Gjithsej kategori",
      value: stats.totalCategories,
      icon: FiFolder,
      color: "indigo",
      bgColor: "bg-indigo-100",
      textColor: "text-indigo-600",
    },
    {
      title: "Të përzgjedhura",
      value: stats.featuredPosts,
      icon: FiStar,
      color: "orange",
      bgColor: "bg-orange-100",
      textColor: "text-orange-600",
    },
    {
      title: "Në trend",
      value: stats.trendingPosts,
      icon: FiTrendingUp,
      color: "red",
      bgColor: "bg-red-100",
      textColor: "text-red-600",
    },
    {
      title: "Postimet e sotme",
      value: stats.todayPosts,
      icon: FiCalendar,
      color: "teal",
      bgColor: "bg-teal-100",
      textColor: "text-teal-600",
    },
  ];

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Pasqyrë e panelit </h1>

      {stats.loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
        </div>
      ) : stats.error ? (
        <div className="bg-red-50 p-4 rounded-lg text-red-600">
          Error loading statistics: {stats.error}
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-6 mb-8">
            {statCards.map((stat) => {
              const Icon = stat.icon;
              return (
                <div
                  key={stat.title}
                  className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow "
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-gray-600">
                        {stat.title}
                      </p>
                      <p
                        className={`text-3xl font-bold ${stat.textColor} mt-2`}
                      >
                        {stat.value}
                      </p>
                    </div>
                    <div className={`p-3 rounded-full ${stat.bgColor}`}>
                      <Icon className={`h-6 w-6 ${stat.textColor}`} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">Veprime të shpejta</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <a
                href="/add-post"
                className="block p-4 bg-blue-50 hover:bg-blue-100 rounded-lg text-center transition-colors"
              >
                <FiPlusCircle className="mx-auto text-3xl text-blue-600 mb-2" />
                <span className="text-blue-600 font-medium">
                  	Krijo postim të ri
                </span>
              </a>
              <a
                href="/posts"
                className="block p-4 bg-green-50 hover:bg-green-100 rounded-lg text-center transition-colors"
              >
                <FiFileText className="mx-auto text-3xl text-green-600 mb-2" />
                <span className="text-green-600 font-medium">Menaxho postimet</span>
              </a>
            </div>
          </div>

          {/* Recent Activity Section */}
          <div className="mt-8 bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">Statistika të shpejta</h2>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Përqindja e përmbajtjes së përzgjedhur	</span>
                <span className="font-semibold">
                  {stats.totalPosts > 0
                    ? `${Math.round(
                        (stats.featuredPosts / stats.totalPosts) * 100
                      )}%`
                    : "0%"}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Norma e përmbajtjes në trend	</span>
                <span className="font-semibold">
                  {stats.totalPosts > 0
                    ? `${Math.round(
                        (stats.trendingPosts / stats.totalPosts) * 100
                      )}%`
                    : "0%"}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Postime të krijuara sot	</span>
                <span className="font-semibold">{stats.todayPosts}</span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminContent;
